import { render, staticRenderFns } from "./CaseStudyBlockKPI.vue?vue&type=template&id=22451c51"
import script from "./CaseStudyBlockKPI.vue?vue&type=script&lang=js"
export * from "./CaseStudyBlockKPI.vue?vue&type=script&lang=js"
import style0 from "./CaseStudyBlockKPI.vue?vue&type=style&index=0&id=22451c51&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports